import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import Left from "@repo/icons/default/Left";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import {
  Page,
  PageDescription,
  PageSection,
  PageTitle,
} from "@/components/ui/layout/page/page";

const NotificationCenterAboutPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Sobre" />
      </HeaderRoot>
      <Page>
        <PageSection>
          <PageTitle>Entenda mais sobre suas notificações</PageTitle>
          <PageDescription>
            As notificações te mantém atualizado sobre o que é mais importante, este é um
            espaço onde você pode resgatar algumas mensagens que pode ter ignorado em
            algum momento.
          </PageDescription>
        </PageSection>
        <PageSection>
          <PageDescription className="pt-4">
            As notificações se dividem em Avisos, Agendamentos e Pagamentos.
          </PageDescription>
          <PageDescription className="pt-4 flex flex-col gap-4">
            <p className="font-semibold">
              Avisos
              <li className="font-normal ml-6">
                Notificações de avisos Livance, Livance Assist ou novidades para você.
              </li>
            </p>
            <p className="font-semibold">
              Agendamentos
              <li className="font-normal ml-6">
                Notificações de consultas e agendamentos.
              </li>
            </p>
            <p className="font-semibold">
              Pagamentos
              <li className="font-normal ml-6">
                Notificações de pagamentos dos seus pacientes.
              </li>
            </p>
          </PageDescription>
        </PageSection>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/home/notification-center/about")({
  component: NotificationCenterAboutPage,
});
